<template>
  <T3Link
    v-if="link.icon?.url"
    class="nav-social-link"
    :to="getLink(link)"
    :title="link.title"
  >
    <UiImg
      :image="link.icon.url"
      :width="link.icon.width"
      :height="link.icon.height"
      aria-hidden="true"
    />
  </T3Link>
</template>

<script>
export default {
  props: {
    link: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getLink({ link, target, title }) {
      return { link, target, title }
    }
  }
}
</script>

<style lang="scss">
.nav-social-link {
  height: 44px;
  width: 44px;
  display: grid;
  place-items: center;
  background-color: color(grey-200);
  border-radius: em(2px);
  transition: background-color 0.2s;

  & > img {
    height: 20px;
    width: 20px;
    filter: color(tarawera, $colors-filter);
  }

  &:is(:hover, :active, :focus) {
    background-color: color(grey-250);
  }
}
</style>
